var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongMokuai(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F465C",
    strokeLinejoin: "round",
    d: "M2.5 2.5H7V7H2.5zM2.5 9H7v4.5H2.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2.5,
    width: 4.5,
    height: 4.5,
    rx: 2.25,
    stroke: "#3F465C",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F465C",
    strokeLinejoin: "round",
    d: "M9 9h4.5v4.5H9z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMi41IiB5PSIyLjUiIHdpZHRoPSI0LjUiIGhlaWdodD0iNC41IiBzdHJva2U9IiMzRjQ2NUMiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHJlY3QgeD0iMi41IiB5PSI5IiB3aWR0aD0iNC41IiBoZWlnaHQ9IjQuNSIgc3Ryb2tlPSIjM0Y0NjVDIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxyZWN0IHg9IjkiIHk9IjIuNSIgd2lkdGg9IjQuNSIgaGVpZ2h0PSI0LjUiIHJ4PSIyLjI1IiBzdHJva2U9IiMzRjQ2NUMiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHJlY3QgeD0iOSIgeT0iOSIgd2lkdGg9IjQuNSIgaGVpZ2h0PSI0LjUiIHN0cm9rZT0iIzNGNDY1QyIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgTongyongMokuai as ReactComponent };